import { Box, Button, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';

export const TypeSmallIconCards = ({
  updateValidationOnChange,
  dataCollection,
  field,
  size,
  errors,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const cards = field.cards;

  function handleSelect(card) {
    updateValidationOnChange(field.key, card.value);
  }

  return (
    <Box className="flex gap-2">
      <Box
        sx={{
          borderRadius: '12px',
          bgcolor: colors.bgInput,
        }}
        className="flex items-center px-[14px]"
      >
        {field.label}
      </Box>
      {cards.map((card) => (
        <Card
          key={card.value}
          card={card}
          isSelected={dataCollection[field.key] === card.value}
          onSelect={handleSelect}
        />
      ))}
    </Box>
  );
};

const Card = ({ card, isSelected, onSelect }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const { Icon, label, value } = card;
  return (
    <Button
      onClick={() => onSelect(card)}
      className=" flex-col"
      sx={{
        border: `1px solid ${
          isSelected ? colors.info + '80' : colors.selected
        }`,
        bgcolor: isSelected ? colors.info + '30' : colors.bgInput,
        padding: '4px 8px',
        minWidth: 'unset',
        height: '56px',
        width: '56px',
        fontSize: '10px',
        ':hover': {
          bgcolor: colors.info + '30',
          border: `1px solid ${colors.info}80`,
        },
      }}
    >
      <Icon sx={{ fontSize: '25px' }} />
      {label}
    </Button>
  );
};
